import React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { cn } from "../../../lib/cn";
import { ChevronDownIcon } from "@radix-ui/react-icons";

const SudoAccordion = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Root
    ref={ref}
    className={cn("w-full", className)}
    {...props}
  />
));
SudoAccordion.displayName = "SudoAccordion";

const SudoAccordionItem = React.forwardRef(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn("border border-app-grey-3 bg-app-menu-color-transparent rounded-md", className)}
    {...props}
  />
));
SudoAccordionItem.displayName = "SudoAccordionItem";

const SudoAccordionTrigger = React.forwardRef(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:bg-app-grey-3 [&[data-state=open]>svg]:rotate-180 focus:outline-none focus:ring-2 focus:ring-app-primary-cta focus:ring-offset-2",
        className
      )}
      {...props}
    >
      {children}
      <ChevronDownIcon className="h-4 w-4 shrink-0 transition-transform duration-200" style={{ color: 'var(--grey-0)' }} />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
SudoAccordionTrigger.displayName = "SudoAccordionTrigger";

const SudoAccordionContent = React.forwardRef(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className="overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
    {...props}
  >
    <div className={cn("pb-4 pt-0", className)}>{children}</div>
  </AccordionPrimitive.Content>
));
SudoAccordionContent.displayName = "SudoAccordionContent";

export { SudoAccordion, SudoAccordionItem, SudoAccordionTrigger, SudoAccordionContent };
